import { render } from "./YourBetslipRetail.vue?vue&type=template&id=21b4897b&scoped=true"
import script from "./YourBetslipRetail.vue?vue&type=script&lang=js"
export * from "./YourBetslipRetail.vue?vue&type=script&lang=js"

import "@/assets/scss/ticket/yourBetslip.scss?vue&type=style&index=0&id=21b4897b&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b4897b"]])

export default __exports__